import i18n from "sveltekit-i18n";
import { dev } from "$app/environment";
import lang from "./lang.json";

export const defaultLocale = "ua";

export const config = {
    log: {
        level: dev ? "warn" : "error",
    },
    translations: {
        ua: { lang },
        en: { lang },
        de: { lang },
        ge: { lang },
        pl: { lang },
        fr: { lang },
    },
    loaders: [
        //UA
        {
            locale: "ua",
            key: "header",
            loader: async () => (await import("./ua/header.json")).default,
        },
        {
            locale: "ua",
            key: "home",
            // routes: ['/'],
            loader: async () => (await import("./ua/home.json")).default,
        },
        {
            locale: "ua",
            key: "news",
            // routes: ['/news', '/news/*'],
            loader: async () => (await import("./ua/news.json")).default,
        },
        {
            locale: "ua",
            key: "donate",
            routes: ["/donate", "/donate-in-game", "/game-purchase"],
            loader: async () => (await import("./ua/donate.json")).default,
        },
        {
            locale: "ua",
            key: "shop",
            routes: ["/shop"],
            loader: async () => (await import("./ua/shop.json")).default,
        },
        {
            locale: "ua",
            key: "cart",
            routes: ["/cart", "/cart/order"],
            loader: async () => (await import("./ua/cart.json")).default,
        },
        {
            locale: "ua",
            key: "how_to_play",
            routes: ["/how-to-play", "/how-to-play/step-1", "/how-to-play/step-2"],
            loader: async () => (await import("./ua/how_to_play.json")).default,
        },
        {
            locale: "ua",
            key: "policy_return",
            routes: ["/policy-return"],
            loader: async () => (await import("./ua/policy_return.json")).default,
        },
        {
            locale: "ua",
            key: "user_agreement",
            routes: ["/user-agreement", "/user-agreement-in-game"],
            loader: async () => (await import("./ua/user_agreement.json")).default,
        },
        {
            locale: "ua",
            key: "policy_privacy",
            routes: ["/privacy-policy"],
            loader: async () => (await import("./ua/policy_privacy.json")).default,
        },
        {
            locale: "ua",
            key: "rp",
            routes: ["/rp"],
            loader: async () => (await import("./ua/rp.json")).default,
        },
        {
            locale: "ua",
            key: "cookies",
            loader: async () => (await import("./ua/cookies.json")).default,
        },
        {
            locale: "ua",
            key: "error",
            loader: async () => (await import("./ua/error.json")).default,
        },
        {
            locale: "ua",
            key: "footer",
            loader: async () => (await import("./ua/footer.json")).default,
        },
        //EN
        {
            locale: "en",
            key: "header",
            loader: async () => (await import("./en/header.json")).default,
        },
        {
            locale: "en",
            key: "home",
            // routes: ['/'],
            loader: async () => (await import("./en/home.json")).default,
        },
        {
            locale: "en",
            key: "news",
            // routes: ['/news', '/news/*'],
            loader: async () => (await import("./en/news.json")).default,
        },
        {
            locale: "en",
            key: "donate",
            routes: ["/donate", "/donate-in-game", "/game-purchase"],
            loader: async () => (await import("./en/donate.json")).default,
        },
        {
            locale: "en",
            key: "shop",
            routes: ["/shop"],
            loader: async () => (await import("./en/shop.json")).default,
        },
        {
            locale: "en",
            key: "cart",
            routes: ["/cart", "/cart/order"],
            loader: async () => (await import("./en/cart.json")).default,
        },
        {
            locale: "en",
            key: "how_to_play",
            routes: ["/how-to-play", "/how-to-play/step-1", "/how-to-play/step-2"],
            loader: async () => (await import("./en/how_to_play.json")).default,
        },
        {
            locale: "en",
            key: "policy_return",
            routes: ["/policy-return"],
            loader: async () => (await import("./en/policy_return.json")).default,
        },
        {
            locale: "en",
            key: "user_agreement",
            routes: ["/user-agreement", "/user-agreement-in-game"],
            loader: async () => (await import("./en/user_agreement.json")).default,
        },
        {
            locale: "en",
            key: "policy_privacy",
            routes: ["/privacy-policy"],
            loader: async () => (await import("./en/policy_privacy.json")).default,
        },
        {
            locale: "en",
            key: "rp",
            routes: ["/rp"],
            loader: async () => (await import("./en/rp.json")).default,
        },
        {
            locale: "en",
            key: "cookies",
            loader: async () => (await import("./en/cookies.json")).default,
        },
        {
            locale: "en",
            key: "error",
            loader: async () => (await import("./en/error.json")).default,
        },
        {
            locale: "en",
            key: "footer",
            loader: async () => (await import("./en/footer.json")).default,
        },
        //DE
        {
            locale: "de",
            key: "header",
            loader: async () => (await import("./de/header.json")).default,
        },
        {
            locale: "de",
            key: "home",
            // routes: ['/'],
            loader: async () => (await import("./de/home.json")).default,
        },
        {
            locale: "de",
            key: "news",
            // routes: ['/news', '/news/*'],
            loader: async () => (await import("./de/news.json")).default,
        },
        {
            locale: "de",
            key: "donate",
            routes: ["/donate", "/donate-in-game", "/game-purchase"],
            loader: async () => (await import("./de/donate.json")).default,
        },
        {
            locale: "de",
            key: "shop",
            routes: ["/shop"],
            loader: async () => (await import("./de/shop.json")).default,
        },
        {
            locale: "de",
            key: "cart",
            routes: ["/cart", "/cart/order"],
            loader: async () => (await import("./de/cart.json")).default,
        },
        {
            locale: "de",
            key: "how_to_play",
            routes: ["/how-to-play", "/how-to-play/step-1", "/how-to-play/step-2"],
            loader: async () => (await import("./de/how_to_play.json")).default,
        },
        {
            locale: "de",
            key: "policy_return",
            routes: ["/policy-return"],
            loader: async () => (await import("./de/policy_return.json")).default,
        },
        {
            locale: "de",
            key: "user_agreement",
            routes: ["/user-agreement", "/user-agreement-in-game"],
            loader: async () => (await import("./de/user_agreement.json")).default,
        },
        {
            locale: "de",
            key: "policy_privacy",
            routes: ["/privacy-policy"],
            loader: async () => (await import("./de/policy_privacy.json")).default,
        },
        {
            locale: "de",
            key: "rp",
            routes: ["/rp"],
            loader: async () => (await import("./de/rp.json")).default,
        },
        {
            locale: "de",
            key: "cookies",
            loader: async () => (await import("./de/cookies.json")).default,
        },
        {
            locale: "de",
            key: "error",
            loader: async () => (await import("./de/error.json")).default,
        },
        {
            locale: "de",
            key: "footer",
            loader: async () => (await import("./de/footer.json")).default,
        },
        //GE
        {
            locale: "ge",
            key: "header",
            loader: async () => (await import("./ge/header.json")).default,
        },
        {
            locale: "ge",
            key: "home",
            // routes: ['/'],
            loader: async () => (await import("./ge/home.json")).default,
        },
        {
            locale: "ge",
            key: "news",
            // routes: ['/news', '/news/*'],
            loader: async () => (await import("./ge/news.json")).default,
        },
        {
            locale: "ge",
            key: "donate",
            routes: ["/donate", "/donate-in-game", "/game-purchase"],
            loader: async () => (await import("./ge/donate.json")).default,
        },
        {
            locale: "ge",
            key: "shop",
            routes: ["/shop"],
            loader: async () => (await import("./ge/shop.json")).default,
        },
        {
            locale: "ge",
            key: "cart",
            routes: ["/cart", "/cart/order"],
            loader: async () => (await import("./ge/cart.json")).default,
        },
        {
            locale: "ge",
            key: "how_to_play",
            routes: ["/how-to-play", "/how-to-play/step-1", "/how-to-play/step-2"],
            loader: async () => (await import("./ge/how_to_play.json")).default,
        },
        {
            locale: "ge",
            key: "policy_return",
            routes: ["/policy-return"],
            loader: async () => (await import("./ge/policy_return.json")).default,
        },
        {
            locale: "ge",
            key: "user_agreement",
            routes: ["/user-agreement", "/user-agreement-in-game"],
            loader: async () => (await import("./ge/user_agreement.json")).default,
        },
        {
            locale: "ge",
            key: "policy_privacy",
            routes: ["/privacy-policy"],
            loader: async () => (await import("./ge/policy_privacy.json")).default,
        },
        {
            locale: "ge",
            key: "rp",
            routes: ["/rp"],
            loader: async () => (await import("./ge/rp.json")).default,
        },
        {
            locale: "ge",
            key: "cookies",
            loader: async () => (await import("./ge/cookies.json")).default,
        },
        {
            locale: "ge",
            key: "error",
            loader: async () => (await import("./ge/error.json")).default,
        },
        {
            locale: "ge",
            key: "footer",
            loader: async () => (await import("./ge/footer.json")).default,
        },
        //PL
        {
            locale: "pl",
            key: "header",
            loader: async () => (await import("./pl/header.json")).default,
        },
        {
            locale: "pl",
            key: "home",
            // routes: ['/'],
            loader: async () => (await import("./pl/home.json")).default,
        },
        {
            locale: "pl",
            key: "news",
            // routes: ['/news', '/news/*'],
            loader: async () => (await import("./pl/news.json")).default,
        },
        {
            locale: "pl",
            key: "donate",
            routes: ["/donate", "/donate-in-game", "/game-purchase"],
            loader: async () => (await import("./pl/donate.json")).default,
        },
        {
            locale: "pl",
            key: "shop",
            routes: ["/shop"],
            loader: async () => (await import("./pl/shop.json")).default,
        },
        {
            locale: "pl",
            key: "cart",
            routes: ["/cart", "/cart/order"],
            loader: async () => (await import("./pl/cart.json")).default,
        },
        {
            locale: "pl",
            key: "how_to_play",
            routes: ["/how-to-play", "/how-to-play/step-1", "/how-to-play/step-2"],
            loader: async () => (await import("./pl/how_to_play.json")).default,
        },
        {
            locale: "pl",
            key: "policy_return",
            routes: ["/policy-return"],
            loader: async () => (await import("./pl/policy_return.json")).default,
        },
        {
            locale: "pl",
            key: "user_agreement",
            routes: ["/user-agreement", "/user-agreement-in-game"],
            loader: async () => (await import("./pl/user_agreement.json")).default,
        },
        {
            locale: "pl",
            key: "policy_privacy",
            routes: ["/privacy-policy"],
            loader: async () => (await import("./pl/policy_privacy.json")).default,
        },
        {
            locale: "pl",
            key: "rp",
            routes: ["/rp"],
            loader: async () => (await import("./pl/rp.json")).default,
        },
        {
            locale: "pl",
            key: "cookies",
            loader: async () => (await import("./pl/cookies.json")).default,
        },
        {
            locale: "pl",
            key: "error",
            loader: async () => (await import("./pl/error.json")).default,
        },
        {
            locale: "pl",
            key: "footer",
            loader: async () => (await import("./pl/footer.json")).default,
        },
        //FR
        {
            locale: "fr",
            key: "header",
            loader: async () => (await import("./fr/header.json")).default,
        },
        {
            locale: "fr",
            key: "home",
            loader: async () => (await import("./fr/home.json")).default,
        },
        {
            locale: "fr",
            key: "news",
            loader: async () => (await import("./fr/news.json")).default,
        },
        {
            locale: "fr",
            key: "donate",
            routes: ["/donate", "/donate-in-game"],
            loader: async () => (await import("./fr/donate.json")).default,
        },
        {
            locale: "fr",
            key: "shop",
            routes: ["/shop"],
            loader: async () => (await import("./fr/shop.json")).default,
        },
        {
            locale: "fr",
            key: "cart",
            routes: ["/cart", "/cart/order"],
            loader: async () => (await import("./fr/cart.json")).default,
        },
        {
            locale: "fr",
            key: "how_to_play",
            routes: ["/how-to-play", "/how-to-play/step-1", "/how-to-play/step-2"],
            loader: async () => (await import("./fr/how_to_play.json")).default,
        },
        {
            locale: "fr",
            key: "policy_return",
            routes: ["/policy-return"],
            loader: async () => (await import("./fr/policy_return.json")).default,
        },
        {
            locale: "fr",
            key: "user_agreement",
            routes: ["/user-agreement", "/user-agreement-in-game"],
            loader: async () => (await import("./fr/user_agreement.json")).default,
        },
        {
            locale: "fr",
            key: "policy_privacy",
            routes: ["/privacy-policy"],
            loader: async () => (await import("./fr/policy_privacy.json")).default,
        },
        {
            locale: "fr",
            key: "rp",
            routes: ["/rp"],
            loader: async () => (await import("./fr/rp.json")).default,
        },
        {
            locale: "fr",
            key: "cookies",
            loader: async () => (await import("./fr/cookies.json")).default,
        },
        {
            locale: "fr",
            key: "error",
            loader: async () => (await import("./fr/error.json")).default,
        },
        {
            locale: "fr",
            key: "footer",
            loader: async () => (await import("./fr/footer.json")).default,
        },
    ],
};

export const { t, loading, locales, locale, translations, loadTranslations, addTranslations, setLocale, setRoute } =
    new i18n(config);

loading.subscribe(async $loading => {
    if ($loading) {
        console.log("Loading translations...");

        await loading.toPromise();
        console.log("Updated translations", translations.get());
    }
});
